import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  TextInput,
  Dimensions,
} from "react-native";
import Text from "app/components/Text";
import Value from "app/components/Value";
import ValueBlur from "app/components/ValueBlur";
import ValueInput from "app/components/ValueInput";
import Generation from "app/components/Generation";
import Canvas from "app/components/Canvas";
import apiActions from "app/utils/apiActions";
import storageActions from "app/utils/storageActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import valueHelpers from "app/utils/valueHelpers";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";

import Hoverable from "app/components/Hoverable";
const createLogger = (msg, value) => () => {
  // console.log(msg, value.name);
};

import {
  Ionicons,
  Octicons,
  FontAwesome,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

const WEB = Platform.OS == "web";
const CONSTELATE = true;

// export default class Overview({navigation}) {
export default class OverviewFocus extends React.Component {
  static navigationOptions = ({
    navigation,
    navigationOptions,
    screenProps,
  }) => {
    return {
      headerShown: false,
    };
  };

  static propTypes = {
    screenProps: PropTypes.shape({
      // values: PropTypes.arrayOf(PropTypes.object),
    }),
  };

  constructor(props) {
    super(props);
    // let { user } = props.screenProps
    // props.navigation
    this.state = {
      values: [],
      fetching: false,
      query: "",
      hideComplete: true,
      showHidden: 0,
      fromBottom: true,
      showOnlyStarred: false,
      showNotes: true,
      showSnoozed: 0,
      showDoneToday: 1,
      familyIds: [],
      selectedValue: null,
      pendingSelectedValue: null,
      lines: [],
      quickActionsId: null,
      enableBlur: true,
      redrawKey: 0,
      consellationKey: 0,
      scrollHeight: Dimensions.get("window").height,
      scrollHeight: null,
      hiddenIds: [],
    };

    let { navigation, route } = this.props;
    navigation.setOptions({
      headerRight: () => (
        <TouchableOpacity onPress={navigation.toggleDrawer}>
          <Ionicons
            name="ios-menu"
            size={32}
            color={colors.foreground}
            style={{ marginRight: 20 }}
          />
        </TouchableOpacity>
      ),
    });
  }

  async componentDidMount() {
    let values = await storageActions.fetchItem("values");
    if (!!values) {
      values = valueHelpers.sortByTimeline(values);
      values = valueHelpers.applyColors(values);
      let hiddenIds = await storageActions.fetchItem("hiddenIds");
      this.setState({ values, hiddenIds });
    }
    this._unsubscribe = this.props.navigation.addListener("focus", () => {
      // this.fetch()
    });
    if (WEB && !!this.filterInput) this.filterInput.focus();
  }

  componentWillUnmount() {
    if (this._unsubscribe) this._unsubscribe();
  }

  fetch = async () => {
    this.setState({ fetching: true });
    console.log("overview fetch...");
    let timestamp = Date.now();
    let values = await apiActions.request("values");
    let duration = (Date.now() - timestamp) / 1000;
    console.log(`fetch completed in ${duration.toFixed(2)} seconds`, values);
    if (!!values) {
      values = valueHelpers.sortByTimeline(values);
      values = valueHelpers.applyColors(values);
      let hiddenIds = await storageActions.fetchItem("hiddenIds");
      this.setState({ values, hiddenIds, fetching: false });
      storageActions.saveItem("values", values);
    } else console.warn("error", values);
  };

  render() {
    let { navigation } = this.props;
    let {
      values,
      fetching,
      query,
      hideComplete,
      showSnoozed,
      showOnlyStarred,
      showNotes,
      showDoneToday,
      showHidden,
      fromBottom,
      familyIds,
      selectedValue,
      lines,
      quickActionsId,
      enableBlur,
      redrawKey,
      scrollHeight,
    } = this.state;

    let buttonColorOptions = [
      colors.trim,
      colors.active,
      colors.activeHighlight,
    ];

    return (
      <View style={styles.container} key={redrawKey}>
        <StatusBar style="auto" />
        <Canvas lines={lines} scrollHeight={scrollHeight} />

        <View style={[styles.row, styles.queryRow]}>
          {fetching ? (
            <ActivityIndicator />
          ) : (
            <TouchableOpacity
              onPress={this.fetch}
              style={[styles.icon, { marginRight: sizes.base }]}
            >
              <Ionicons
                name="md-refresh"
                size={sizes.itemHeight}
                color={colors.active}
              />
            </TouchableOpacity>
          )}
          <TextInput
            ref={(c) => (this.filterInput = c)}
            onKeyPress={this.handleKeyPress}
            style={styles.input}
            placeholderTextColor={colors.placeholder}
            value={query}
            placeholder={"filter"}
            onChangeText={(query) => this.setState({ query })}
          />
          <TouchableOpacity
            onPress={() => this.setState({ hideComplete: !hideComplete })}
            style={styles.icon}
          >
            <Feather
              name={"check-circle"}
              size={sizes.itemHeight}
              color={hideComplete ? colors.trim : colors.active}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ fromBottom: !fromBottom })}
            style={{ marginLeft: sizes.base }}
          >
            <Entypo
              name="flow-tree"
              size={sizes.itemHeight}
              color={fromBottom ? colors.trim : colors.active}
              style={fromBottom ? null : { transform: [{ rotateZ: "180deg" }] }}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              this.setState({
                showSnoozed: showSnoozed >= 2 ? 0 : showSnoozed + 1,
              })
            }
            style={{ marginLeft: sizes.base }}
          >
            <FontAwesome
              name="moon-o"
              size={sizes.itemHeight}
              color={buttonColorOptions[showSnoozed]}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ redrawKey: redrawKey + 1 })}
            style={styles.icon}
          >
            {/*<MaterialCommunityIcons name="draw" size={sizes.itemHeight} color={colors.trim} />*/}
            <Text style={{ color: colors.trim }}>RE</Text>
          </TouchableOpacity>
          {/*<TouchableOpacity onPress={() => this.setState({showOnlyStarred: !showOnlyStarred})} style={styles.icon}>
            <Ionicons name={`ios-star${showOnlyStarred ? '' : '-outline'}`} size={sizes.itemHeight} color={showOnlyStarred ? colors.active : colors.trim} />
          </TouchableOpacity>*/}
          {/*<TouchableOpacity onPress={() => this.setState({showNotes: !showNotes})} style={styles.icon}>
            <Octicons name={`note`} size={sizes.itemHeight} color={showNotes ? colors.active : colors.trim} />
          </TouchableOpacity>*/}
          <TouchableOpacity
            onPress={() => this.setState({ enableBlur: !enableBlur })}
            style={styles.icon}
          >
            <FontAwesome
              name={"search"}
              size={sizes.itemHeight - 4}
              color={enableBlur ? colors.trim : colors.active}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              this.setState({
                showDoneToday: showDoneToday >= 2 ? 0 : showDoneToday + 1,
              })
            }
            style={styles.icon}
          >
            <FontAwesome
              name={"calendar-check-o"}
              size={sizes.itemHeight - 4}
              color={buttonColorOptions[showDoneToday]}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              this.setState({
                showHidden: showHidden >= 2 ? 0 : showHidden + 1,
              })
            }
            style={styles.icon}
          >
            <Ionicons
              name="md-eye-off"
              size={sizes.itemHeight - 4}
              color={buttonColorOptions[showHidden]}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => navigation.navigate("Create")}
            style={styles.icon}
          >
            <Ionicons
              name="ios-add-circle-outline"
              size={sizes.itemHeight}
              color={colors.foreground}
            />
          </TouchableOpacity>
        </View>

        <TouchableWithoutFeedback
          onPress={() => {
            this.hoverOut();
            this.setState({ quickActionsId: null });
          }}
        >
          <View style={{ flex: 1, justifyContent: "space-between" }}>
            {this.renderLevels()}
          </View>
        </TouchableWithoutFeedback>

        <View />
      </View>
    );
  }

  renderLevels = () => {
    let { navigation } = this.props;
    let {
      values,
      fetching,
      query,
      fromBottom,
      familyIds,
      selectedValue,
      lines,
      quickActionsId,
      enableBlur,
      consellationKey,
    } = this.state;
    values = valueHelpers.sortByTimeline(values);
    // values = valueHelpers.applyColors(values)
    values = this.applyFilters(values);
    // values = values.map(v => ({...v, level: textHelpers.determineLevel(v, values, fromBottom)}))
    let topLevel = valueHelpers.topLevel(values);
    let levels = this.levelsArray(values, topLevel);
    values = this.applyFilters(values, false);

    return (
      <ScrollView
        style={{ flex: 1, paddingBottom: 100 }}
        contentContainerStyle={[styles.levelRowsWrapper]}
      >
        {levels.map((level) => {
          let levelValues = values.filter((v) => v.level == level); //.reverse()

          if (level != 0) {
            // levelValues = levelValues.filter(v => familyIds.includes(v.id))
            levelValues = levelValues.map((v) =>
              familyIds.includes(v.id) ? v : { ...v, filler: true },
            );
          }

          let step = 255 / Math.max(1, levels.length - 1);
          let red = level * step;
          let scalePerc = 1.0 + 1 * (level / topLevel);
          let opacityPerc = 1.0 - 1 * (level / topLevel);
          let shelfMarginPerc = -70;
          let marginPerc = -50;
          let distance = 0.5 * (level / topLevel);
          scalePerc = 1;
          distance = 0;
          marginPerc = 0;
          shelfMarginPerc = 0;

          let levelScale = 1.0 + 0.5 * (level / topLevel);
          let maxSize = 110 * levelScale;
          let minSize = 90 * levelScale;
          let size = maxSize;
          let minWrapperSize = maxSize / 2 + maxSize / 8;
          // minWrapperSize = maxSize - (minWrapperSize*(level/topLevel))
          // minWrapperSize = maxSize
          minWrapperSize = 20;
          let gutterSize = (size / 2) * screenRatio * 0.2 * 3;
          let outterSize = size + gutterSize;
          let maxOutterSize = outterSize;

          return (
            <View
              key={`level-${level}`}
              style={[
                styles.row,
                {
                  padding: 0,
                  // flexGrow: 0,
                  height: maxOutterSize + gutterSize,
                },
              ]}
            >
              <ScrollView
                key={`level-${level}`}
                style={[styles.rowScroller]}
                contentContainerStyle={[
                  styles.rowScrollerContainer,
                  {
                    paddingLeft: minWrapperSize / 2,
                    // marginBottom: level == 0 ? 60 : 0,
                  },
                ]}
                horizontal
              >
                <View style={styles.rowScrollerContent}>
                  {levelValues.map((value, i) => (
                    <Hoverable
                      key={i}
                      onHoverIn={() => {
                        if (value.filler) return;
                        this.hoverIn(value, false);
                      }}
                      // onHoverOut={() => this.hoverOut(value)}
                    >
                      {(isHovered) => {
                        if (value.filler) isHovered = false;
                        if (!!selectedValue) isHovered = false;
                        // let selected = !!selectedValue && selectedValue.id == value.id
                        let selected = familyIds.includes(value.id);

                        size = selected || isHovered ? maxSize : minSize;
                        gutterSize = (size / 2) * screenRatio * 0.2 * 3;
                        outterSize = size + gutterSize;

                        return (
                          <View
                            style={[
                              styles.valueWrapper,
                              {
                                minWidth: minWrapperSize,
                                minHeight: maxOutterSize,
                                zIndex:
                                  selected || isHovered
                                    ? 9999
                                    : levelValues.length - i,
                              },
                              {
                                transform: [{ scale: scalePerc }],
                                marginBottom: marginPerc,
                                opacity:
                                  !!familyIds.length &&
                                  !familyIds.includes(value.id)
                                    ? 0.2
                                    : 1,
                              },
                            ]}
                          >
                            <Value
                              size={size}
                              value={value}
                              key={`value-${value.id}-${consellationKey}`}
                              ref={(ref) => {
                                this[`val_${value.id}`] = ref;
                              }}
                              selected={selected}
                              onDeselect={() => this.hoverOut(value)}
                              onPress={() => {
                                if (value.filler) {
                                  this.hoverOut();
                                } else if (
                                  !!selectedValue &&
                                  selectedValue.id == value.id
                                ) {
                                  RootNavigation.navigate("Value", {
                                    value,
                                    id: value.id,
                                  });
                                } else if (selected) {
                                  this.hoverIn(value);
                                } else if (!!selectedValue) {
                                  this.hoverOut();
                                } else {
                                  this.hoverIn(value);
                                }
                              }}
                              style={[
                                {
                                  position: "absolute",
                                  left: -outterSize / 2,
                                  top: -outterSize / 2,
                                },
                              ]}
                              distance={
                                familyIds.includes(value.id) ? 0 : distance
                              }
                              maxWidth={250}
                              filterToFamily={() =>
                                this.handleFilterToFamily(value)
                              }
                              onUpdate={(val) => this.handleUpdate(val)}
                              showQuickActions={quickActionsId == value.id}
                              onShowQuickActions={() =>
                                this.setState({ quickActionsId: value.id })
                              }
                              onHideQuickActions={() =>
                                this.setState({ quickActionsId: null })
                              }
                            />
                          </View>
                        );
                      }}
                    </Hoverable>
                  ))}
                </View>
              </ScrollView>
            </View>
          );
        })}
      </ScrollView>
    );
  };

  handleUpdate = async (val) => {
    let newValues = this.state.values.map((v) =>
      v.id == val.id ? { ...v, ...val } : v,
    );
    newValues = valueHelpers.sortByTimeline(newValues);
    newValues = valueHelpers.applyColors(newValues);
    storageActions.saveItem("values", newValues);
    let hiddenIds = await storageActions.fetchItem("hiddenIds");
    this.setState({ values: newValues, hiddenIds, query: "" });
  };

  applyFilters = (values, affectLeveling = true) => {
    let {
      hideComplete,
      showOnlyStarred,
      showNotes,
      showDoneToday,
      showHidden,
      showSnoozed,
      query,
      hiddenIds,
    } = this.state;
    if (hideComplete) {
      // values = values.filter(v => textHelpers.doneSinceMilestone(v).length < 7 && !v.completed_at)
      values = values.filter((v) => !!!v.completed_at);
    }

    if (showSnoozed == 0)
      // none
      values = values.filter((v) => !valueHelpers.isSnoozed(v));
    else if (showSnoozed == 1)
      // either
      values = values;
    else if (showSnoozed == 2)
      // only
      values = values.filter((v) => valueHelpers.isSnoozed(v));

    if (showOnlyStarred) {
      // values = values.filter(v => v.starred)
    }
    if (!showNotes) {
      values = values.filter((v) => {
        if (v.child_ids.length == 0) {
          // notes cannot have children
          if (
            v.timeline.length == 2 &&
            v.milestones[0].indexOf("note from") == 0
          ) {
            // only entry is created as a note from parent value
            return false;
          } else if (
            v.timeline.length == 1 &&
            !timeHelpers.wasToday(v.timeline[0].timestamp)
          ) {
            // only entry is created at, and it wasn't today
            return false;
          }
        }
        return true;
      });
    }
    if (showDoneToday == 0 && !affectLeveling) {
      values = values.filter((v) => !textHelpers.wasDoneToday(v, true));
    }
    if (showDoneToday == 2) {
      let doneToday = values.filter((v) => textHelpers.wasDoneToday(v, true));
      let parentIds = doneToday.reduce(
        (ids, val) => [...ids, ...val.parent_ids],
        [],
      );
      while (parentIds.length) {
        let newDoneToday = values.filter(
          (v) => parentIds.indexOf(v.id) >= 0 && doneToday.indexOf(v) < 0,
        );
        parentIds = newDoneToday.reduce(
          (ids, val) => [...ids, ...val.parent_ids],
          [],
        );
        doneToday = [...doneToday, ...newDoneToday];
      }
      values = doneToday;
    }

    hiddenIds = hiddenIds || [];
    // if((showHidden==0 || showHidden==2) && !affectLeveling){
    if (showHidden == 0 || showHidden == 2) {
      let shouldRemove = showHidden == 2;
      values = values.filter((v) => {
        if (hiddenIds.includes(v.id)) return shouldRemove;
        else if (v.parent_ids.length == 1) {
          if (hiddenIds.includes(v.parent_ids[0])) {
            // console.log(`hiding ${v.text} bc only parent is hidden: ${v.parent_ids[0]}`)
            hiddenIds.push(v.id);
            return shouldRemove;
          } else {
            return !shouldRemove;
          }
        }
        return !shouldRemove;
      });
    }
    // console.log('hiddenIds', hiddenIds)

    if (!affectLeveling) {
      // hide if level > 0 and no visible children
      // values = values.filter(v => !(v.level > 0 && !values.find(f => v.child_ids.includes(f.id) )))
    }

    values =
      !!query && query.length > 0
        ? values.filter((v) => {
            return (
              v.text.indexOf(query) >= 0 ||
              (!!v.revisions &&
                v.revisions.find((r) => r.text.indexOf(query) >= 0))
            );
          })
        : values;

    return values;
  };

  levelsArray = (values, topLevel) => {
    let { fromBottom } = this.state;
    let levels = new Array(topLevel + 1).fill(0).map((x, i) => i);
    if (fromBottom) levels = levels.reverse();
    return levels;
  };

  handleClickValue = (value) => {
    let { values } = this.state;
    value.clicked = true;
    values.map((v) => (v.id == value.id ? value : v));
    this.setState({ values });
  };

  handleFilterToFamily = (value) => {
    let fam = [value];

    let children = values.filter(
      (v) => v.parent_ids && v.parent_ids.includes(value.id),
    );
    fam = [...fam, ...children];

    let grandchildren = values.filter(
      (v) =>
        children.filter((c) => !!c.child_ids && c.child_ids.includes(v.id))
          .length > 0 && fam.filter((f) => f.id == v.id).length == 0,
    );
    fam = [...fam, ...grandchildren];

    let parents = values.filter(
      (v) =>
        v.child_ids &&
        v.child_ids.includes(value.id) &&
        fam.filter((f) => f.id == v.id).length == 0,
    );
    fam = [...fam, ...parents];

    let grandparents = values.filter(
      (v) =>
        parents.filter((p) => p.parent_ids && p.parent_ids.includes(v.id))
          .length > 0 && fam.filter((f) => f.id == v.id).length == 0,
    );
    fam = [...fam, ...grandparents];

    this.setState({ values: fam });
  };

  constelate = (value, upwards = true) => {
    let lines = [];
    if (!!!this[`val_${value.id}`]) return lines;
    // console.log(this[`val_${value.id}`].state.absX, this[`val_${value.id}`].state.absY)
    let origin = [
      this[`val_${value.id}`].state.absX,
      this[`val_${value.id}`].state.absY,
      // this[`val_${value.id}`].state.absX ,
      // this[`val_${value.id}`].state.absY,
      value.id,
    ];

    let targetIds = upwards ? value.parent_ids : value.child_ids;
    // console.log(value, upwards, targetIds)
    // return []
    let targetXs = [];
    targetIds.forEach((id) => {
      if (!!this[`val_${id}`]) {
        let pointX = this[`val_${id}`].state.absX;
        if (targetXs.includes(pointX)) pointX += 10;
        targetXs.push(pointX);
        let pointY = this[`val_${id}`].state.absY;
        let point = [pointX, pointY, id];
        lines.push([origin, point]);
      }
    });
    return lines;
  };

  hoverIn = async (value, replaceSelection = true) => {
    // this.setState({pendingSelectedValue: value})
    // await new Promise(resolve => setTimeout(resolve, 2000));
    // if(this.state.pendingSelectedValue?.id != value.id) return

    if (!!this.state.selectedValue && !replaceSelection) return;

    console.log(value);
    let { values } = this.state;
    let familyIds = [value.id];
    let lines = [];

    if (CONSTELATE) lines = [...lines, ...this.constelate(value, true)];

    // let familyIds = textHelpers.getFamilyIds(value)

    let parentIds = value.parent_ids;
    while (parentIds.length) {
      familyIds = [...familyIds, ...parentIds];
      let parents = values.filter((v) => parentIds.includes(v.id));
      parentIds = parents.map((v) => v.parent_ids).flat();
      if (CONSTELATE)
        parents.forEach(
          (val) => (lines = [...lines, ...this.constelate(val, true)]),
        );
    }

    if (CONSTELATE) lines = [...lines, ...this.constelate(value, false)];

    let childIds = value.child_ids;
    while (childIds.length) {
      familyIds = [...familyIds, ...childIds];
      let children = values.filter((v) => childIds.includes(v.id));
      childIds = children.map((v) => v.child_ids).flat();
      if (CONSTELATE)
        children.forEach(
          (val) => (lines = [...lines, ...this.constelate(val, false)]),
        );
    }

    familyIds = [...new Set(familyIds)];

    let selectedValue = replaceSelection ? value : this.state.selectedValue;
    this.setState({ familyIds, lines, selectedValue });
  };

  hoverOut = (value = null) => {
    this.setState({
      familyIds: [],
      selectedValue: null,
      pendingSelectedValue: null,
      lines: [],
    });
  };

  handleKeyPress = (event) => {
    console.log("keypress:", event.keyCode, event.keyValue);
    let triggerKey = false;
    // 13 == enter
    // 9 == tab
    if (event.keyCode == 9) {
      return;
      event.preventDefault();
      console.log("tab");
      if (this.state.shiftIsDown) {
        console.log("unindent!");
        // this.handleUnindentItem(item)
      } else {
        // this.handleIndentItem(item)
      }
    } else if (event.keyCode == 13) {
      event.preventDefault();
      console.log("enter");
      // this.handleAppendItem(item)
    } else if (event.keyCode == 8) {
      console.log("backspace");
      // if(item.text == ''){
      // this.handleDeleteItem(item)
      // }
    } else if (event.keyCode == 16) {
      console.log("shift down");
      this.setState({ shiftIsDown: true });
      triggerKey = true;
    } else if (event.keyCode == 27) {
      console.log("escape");
      this.setState({ query: "" });
    }
    // 38 // up
    // 39 // right
    // 40 // down
    // 37 // left
    if (!triggerKey) {
      this.setState({ shiftIsDown: false });
    }
  };
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-around",
    // backgroundColor: '#111',
  },
  row: {
    flexGrow: 1,
    borderColor: colors.trim,
    // borderBottomWidth: 1,
    alignSelf: "stretch",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    padding: sizes.large,
  },
  rowScroller: {
    flex: 1,
    alignSelf: "stretch",
    flexDirection: "row",
    flexWrap: "nowrap",
    // borderWidth: 1, borderColor: 'red',
  },
  rowScrollerContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    // justifyContent: 'space-around',
    // borderWidth: 5, borderColor: 'blue'
  },
  rowScrollerContent: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-start",
    // justifyContent: 'space-around',
  },
  rowContent: {
    // borderWidth: 1, borderColor: 'white',
    // flex: -1,
    flex: 1,
    flexDirection: "row",
    alignSelf: "center",
    // justifyContent: 'center',
    // justifyContent: 'space-around',
    justifyContent: "flex-start",
    flexWrap: "wrap",
    flexWrap: "nowrap",
    // paddingLeft: sizes.base*4,
  },
  valueWrapper: {
    flex: 1,
    // flexGrow: 0,
    justifyContent: "center",
    alignItems: "center",
    // borderColor: 'white', borderWidth: 2,
    alignSelf: "stretch",
  },
  queryRow: {
    flexGrow: 0,
    height: 50,
    padding: sizes.base,
    justifyContent: "flex-start",
  },
  input: {
    ...styleSheet.input,
    alignSelf: "stretch",
    flex: 1,
  },
  icon: {
    marginLeft: sizes.base,
    minWidth: sizes.base,
    minHeight: sizes.base,
    // borderWidth: 1, borderColor: 'white',
  },
  levelRowsWrapper: {
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "stretch",
  },
});
